import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fn from '../../Functii'
import moment from 'moment'
// import TeaserText from './TeaserText'
import { acAxiosWidgetPromotie } from '../actions/acAxiosWidgetPromotie';
import { acPopVizibil } from '../actions/acPopVizibil'
import { acWidgetToggle } from '../actions/acWidgetToggle'

class WidgetPromotie extends React.Component {

    constructor() {
        super();
        this.state = {
            class: true,
            nrRows: 10,
        }

    }
    componentDidMount() {
        this.props.acAxiosWidgetPromotie([this.props.appProps.ruta, this.props.sessionParam]);
        clearInterval(this.interval);
        this.interval = setInterval(function () {
            this.promotie();
        }.bind(this), 10000); //10s, in backend se actualizeaza la 1min
    }
    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
            // clearTimeout(this.timeout)
        }
    }
    promotie() {
        if (this.props.widgetPromotie?.newLeaderboard?.constructor === Array && this.props.widgetPromotie?.newLeaderboard?.length >= 3) {
            this.props.acAxiosWidgetPromotie([this.props.appProps.ruta, this.props.sessionParam, this.props.widgetPromotie.newLeaderboard, this.props.widgetPromotie.newUser]);
        }
    }
    leaderboard() {
        if (this.props.widgetPromotie.prevLeaderboard) {
            var wp = this.props.widgetPromotie;

            var leaderboardChanged = [];

            for (var q = 0; q < wp.newLeaderboard.length; q++) {
                // console.log('aici', filtreNewI[0]['nr. crt.'], '===', q - 1);
                if (wp.prevLeaderboard[q] && wp.prevLeaderboard[q].username) {
                    let newUsername = wp?.newLeaderboard[q]?.username ? wp.newLeaderboard[q].username : null
                    let prevUsername = wp?.prevLeaderboard[q]?.username ? wp.prevLeaderboard[q].username : null
                    var filtreNew = newUsername ? wp.newLeaderboard.filter(x => x.username === newUsername) : null
                    var filtrePrev = prevUsername ? wp.prevLeaderboard.filter(x => x.username === prevUsername) : null
                    // console.log('filtrePrev', filtrePrev, 'filtreNew', filtreNew);
                    leaderboardChanged.push({
                        username: filtreNew[0].username,
                        points: filtreNew[0].points,
                        pointsChange: filtreNew[0].points - filtrePrev[0].points,
                        prize: filtreNew[0].prize
                    })
                }
                if (filtreNew[0].points - filtrePrev[0].points > 0) {
                    // console.log('--->', filtreNew[0].username, filtreNew[0].points - filtrePrev[0].points);
                }
            }

            leaderboardChanged.sort(function (a, b) {
                return parseFloat(b.points) - parseFloat(a.points);
            });
            return this.leaderboardTr(leaderboardChanged);
        } else {
            return this.leaderboardTr(this.props.widgetPromotie.newLeaderboard);
        }

    }
    leaderboardTr(val) {
        var filtreNew = this.props.widgetPromotie.newLeaderboard.filter(x => x['nr. crt.'] === this.props.widgetPromotie.newUser.position)
        var tr = [];
        for (var i = 0; i < this.state.nrRows; i++) {
            var i2 = i + 1;
            if(val[i]) {

                if (filtreNew && filtreNew[0] && filtreNew[0]['nr. crt.'] < this.state.nrRows && filtreNew[0]['nr. crt.'] === i + 1) {
                    tr.push(
                        <tr key={i} className={this.classUp(val[i].pointsChange) + 'pozitiaTa'}>
                            <td>{this.top3(i2)}</td>
                            <td><span>{this.props.multiLang.position.txt}</span>{val[i].username}</td>
                            <td>{val[i].points}{this.pointsChange(val[i].pointsChange)}</td>
                            <td>{val[i].prize + ' RON'}</td>
                        </tr>)
                } else {
                    tr.push(
                        <tr key={i} className={this.classUp(val[i].pointsChange)}>
                            <td>{this.top3(i2)}</td>
                            <td>{val[i].username}</td>
                            <td>{val[i].points}{this.pointsChange(val[i].pointsChange)}</td>
                            <td>{val[i].prize + ' RON'}</td>
                        </tr>)
                }
            }
        }
        tr.push(
            <tr key="lastRow">
                <td colSpan="4" className="dots">...</td>
            </tr>
        )
        return tr
    }
    top3(val) {
        if (val <= 3) {
            return <img src={"img/icon/ic" + val + ".png"} alt="" />
        } else {
            return val
        }
    }
    pointsChange(val) {
        if (val > 0) {
            // console.log('points change', val);
            return ' (+' + val + ')';
        }
    }
    classUp(val) {
        if (val > 0) {
            return 'up';
        } else {
            return ''
        }
    }
    user() {
        // var filtreNew = this.props.widgetPromotie.newLeaderboard.filter(x => x['nr. crt.'] === this.props.widgetPromotie.newUser.position)
        if (this.props.widgetPromotie.newUser.username !== null && ((this.props.widgetPromotie.newUser.position > this.state.nrRows) || (this.props.widgetPromotie.newUser.position === '100+'))) {
            // if (this.props.widgetPromotie.newUser.username !== null) {
            var prize = ''
            if (this.props.widgetPromotie.newUser.position !== '+100' && this.props.widgetPromotie.newUser.position < 100) {
                var filtreUser = this.props.widgetPromotie.newLeaderboard.filter(x => x['nr. crt.'] === parseInt(this.props.widgetPromotie.newUser.position, 10))
                prize = filtreUser[0].prize;
            } else {
                prize = '-'
            }

            if (this.props.widgetPromotie.prevUser) {
                var pointsChange = this.props.widgetPromotie.newUser.points - this.props.widgetPromotie.prevUser.points;
            } else {
                pointsChange = 0;
            }
            var arr = [];
            arr.push(<tr key="1"><td colSpan="4" className="poz-ta">{this.props.multiLang.position.txt}:</td></tr>)
            arr.push(<tr key="3" className={"leaderboard-user " + this.classUp(pointsChange)}>
                <td>{this.props.widgetPromotie.newUser.position}</td>
                <td>{this.props.widgetPromotie.newUser.username}</td>
                <td>{this.props.widgetPromotie.newUser.points} {this.pointsChange(pointsChange)}</td>
                <td>{prize}</td>
            </tr>)
            arr.push(<tr key="2"><td colSpan="4" className="dots">...</td></tr>)
            return arr;
        }
    }
    prize(val) {
        if (val > 0) {
            return val
        } else {
            return '-'
        }
    }
    clasament(e) {
        this.props.acPopVizibil({
            vizibil: true,
            position: { x: 'auto', y: 50 },
            info: { type: 'clasamentWidget' }
        })
        e.stopPropagation();
    }
    toggleMobile() {
        if (this.props.widgetToggle === true) {
            return 'mob'
        } else {
            return ''
        }
    }
    toggleOverlay() {
        if (this.props.conSizeChange.appW < 1000) {
            this.props.acWidgetToggle(!this.props.widgetToggle)
        }
    }
    render() {

        if (this.props.multiLang && 
            this.props.widgetPromotie !== null && 
            this.props.widgetPromotie.newLeaderboard && 
            this.props.widgetPromotie.newLeaderboard.constructor === Array && 
            this.props.widgetPromotie.newLeaderboard.length >= 3) {
            // console.log('wigetPromotie', this.props.widgetPromotie);
            return (
                <div className={"widget-promotion " + this.toggleMobile()}>
                    <div onClick={this.toggleOverlay.bind(this)} className="module-header">
                        {this.props.widgetPromotie.promotion_name.split(" ").length >= 3 ? this.props.widgetPromotie.promotion_name.split(" ")[0] + " " + this.props.widgetPromotie.promotion_name.split(" ")[1] + " " + this.props.multiLang.week.txt + " " + this.props.widgetPromotie.promotion_name.split(" ")[2] : this.props.multiLang.cursaLoteriilor.txt}    
                    </div>
                    <div className="win"><div>{moment(this.props.widgetPromotie.promotion_start).format("DD/MM/YYYY") + ' - ' + moment(this.props.widgetPromotie.promotion_end).format("DD/MM/YYYY")}</div><div><span>{fn.points(parseInt(this.props.widgetPromotie.prize_value)) + ' ' + this.props.defaultVal.currency}</span></div></div>
                    {(this.props.conSizeChange && this.props.conSizeChange.appW && this.props.conSizeChange.appW >= 1000) ? 
                        <a rel="noopener noreferrer" href="https://casino.netbet.ro/cursa-loteriilor-decembrie" target="_blank" className="detaliiPromo">
                            <div className="teaser"><img src={"img/promo/Cover_360.jpg"} alt="" /></div>
                        </a> : null}
                    <div className="con-leaderboard">
                        <table>
                            <thead>
                                <tr>
                                    <th>{this.props.multiLang.loc.txt}</th>
                                    <th>{this.props.multiLang.user.txt}</th>
                                    <th>{this.props.multiLang.points.txt}</th>
                                    <th>{this.props.multiLang.prize.txt}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.user()}
                                {this.leaderboard()}
                            </tbody>
                        </table>
                    </div>
                    <div onClick={this.clasament.bind(this)} className="leaderboard-footer">
                        <div><img src={"img/icon/top.png"} alt="" /><span>{this.props.multiLang.veziClasament.txt}</span></div>
                    </div>
                </div>
            )
        } else {
            return <div></div>
        }
    }
}

function mapStateToProps(state) {
    return {
        widgetPromotie: state.widgetPromotie,
        defaultVal: state.defaultVal,
        multiLang: state.multiLang,
        appProps: state.appProps,
        sessionParam: state.sessionParam,
        conSizeChange: state.conSizeChange,
        widgetToggle: state.widgetToggle
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acAxiosWidgetPromotie: acAxiosWidgetPromotie,
        acPopVizibil: acPopVizibil,
        acWidgetToggle: acWidgetToggle,
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(WidgetPromotie);

// export default TopWiners